import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useSelector } from 'react-redux'

import {
  selectCockpitOffering,
  selectCockpitSelectedAttentionStatusOffering,
} from '../../../model/selectors'

/**
 * The offering a status' detail section is stated for.
 *
 * Acknowledgment and completeness are both measured per offering, so the tile's own offering
 * scopes them. `Overall` is not an offering a plan is signed for or measured on — there the list
 * states a status once per offering that raised it, and the row the reader opened names the
 * offering its detail answers. No section picks one of its own.
 */
export const useAttentionDetailOffering = (): ProgramTypes | null => {
  const cockpitOffering = useSelector(selectCockpitOffering)
  const raisedFor = useSelector(selectCockpitSelectedAttentionStatusOffering)

  if (cockpitOffering !== ProgramTypes.Overall) {
    return cockpitOffering
  }

  return (raisedFor as ProgramTypes) || null
}
